export const validateEmail = (email) => {
    const emailRegex = /^(?![._])(?!.*[._]{2})[a-zA-Z0-9._-]{1,64}@[a-zA-Z0-9-]{1,253}\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
}
export const validatePassword = (password) => {
    return password.length < 8 ? false : true
}
export const validatePasswordCheck = (pw, pwchk) => {
    return (pw !== '' && pw === pwchk) ? true : false
}

export const validateName = (name) => {
    return name.length < 41 ? true : false
}

export const validateTel = (tel) => {
    if (!tel) return true;

    const telRegex = /^\d{10,11}$/;
    return telRegex.test(tel)
}

export const validateRequire = (value) => {
    return value.length > 1 ? true : false
}